<template>
    <b-overlay :show="showoverlay" rounded="sm" >


       <div class="card bg-white">
            <div class="card-body">
                <div class="row no-margin">
                    <div class="align-self-center col-sm-6 px-0" style="font-size: 16px;">
                        <label>Leavers Bulk Update</label>
                        <div class="custom-search">
                            <b-form-file class="max-450" id="datafile_leaver_wizard" name="datafile_leaver_wizard" @change="uploadLeaverFile"  accept=".xlsx,.xls"></b-form-file>
                        </div>
                        <template v-if="addons.includes('Pf') && $atl_company_package_title != 'Provident Fund Only'">

                            <b-form-group id="pf-end-date-bulk-group" class=''>
                            <b-form-checkbox id="checkbox-3" v-model="pf_end_date_enable_bulk"  name="pf_end_bulk" value=1 unchecked-value=0 >
                            End PF Entitlement of the employees on leave date.
                            </b-form-checkbox>
                            </b-form-group>
                    </template>
                    </div>
                    <div class="align-self-end pt-1 col-sm-6 px-0 text-right">
                        <b-button :href="$api_url+'/leaver/template/'+current_fiscal_year+'/'+current_month"><b-icon icon="code-slash" ></b-icon> Download Template</b-button>
                    </div>
                </div>
            </div>
        </div>


        <div class="card rounded-border bg-wash no-shadow mt-3">
            <div class="card-header ">
                <div class="card-header-inner clearfix my-3">
                    <div class="float-left align-self-center pt-1 col-sm-4 px-0" style="font-size: 18px;">Total employees <span class="ml-2" style="color: #5A8DEE;">{{people}}</span></div>
                    <div class="float-left align-self-center col-sm-8 custom-search pr-0">
                        <b-input-group >
                            <b-input-group-prepend is-text>
                                <b-icon icon="search"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="search" placeholder="Search...." v-model="search" @input="setSearch()"></b-form-input>
                        </b-input-group>
                    </div>
                </div>
            </div>
            <div class="card-body container px-0 pt-0 employee-table-wrapper">
                <table class="table table-borderless employee-list-table dataTable">
                    <thead>
                        <tr class="table-head">
                            <!--<td>Name</td>
                            <td>Job Position</td>
                            <td>Department</td>
                            <td>Leave Date</td>
                            <td class="text-right">Action</td>-->
                            <th v-for="column in columns" :key="column.name" @click="sortBy(column.name)":class="sortKey === column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'" style="cursor:pointer;"><span>{{column.label}}</span></th>

                            <th class="text-right">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                    <template v-if="paginatedData">
                        <tr class="table-row hover-bg" v-for="employee_data in paginatedData" :key="employee_data.employee_id">
                            <td>
                                <img v-if="employee_data.pic != 'no-image.jpg' && employee_data.pic != ''" v-bind:src="$api_url+'/avatar/'+ employee_data.company_id + '/' + employee_data.pic" class="img-fluid img-thumbnail employee-avatar mr-2" />
                                <img v-else v-bind:src="$api_url+'/avatar/demo.jpg'" class="img-fluid img-thumbnail employee-avatar mr-2" />
                                {{employee_data.name}}
                            </td>
                            <td>{{employee_data.employee_code}}</td>
                            <td>{{employee_data.jobposition}}</td>
                            <td>{{employee_data.department}}</td>
                            <td><div v-if="employee_data.leave_date && employee_data.leave_date != '0000-00-00'">{{employee_data.leave_date}}</div><div v-else>N/A</div></td>
                            <td class="position-relative text-right">
                                <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                    <b-button class="text-left" variant="secondary" @click="updateLeaver(employee_data.employee_id,employee_data.name)">Update</b-button>
                                </div>
                            </td>
                        </tr>
                    </template>
                    </tbody>
                </table>

                <div class="row py-2 no-margin" v-if="paginatedData.length > 0">
                    <div class="col-md-12 p-0 no-margin" v-if="paginatedData.length > 0">
                        <ul class="pagination b-pagination float-left mb-0 mt-1">
                            <li class="page-item disabled m-2">View</li>
                            <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
                            <li class="page-item disabled m-2">per page. Total {{people}} records found.</li>
                        </ul>
                        <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ></b-pagination-nav>
                    </div>

                </div>
                <div class="row p-4 no-gutters justify-content-center align-items-center" v-if="paginatedData.length == 0">
                    <p class="mb-0 mr-3">{{blankmsg}}</p><b-button variant="primary" class="mb-0" :href="'/employee/info'">Add Employee</b-button>
                </div>

            </div>

            <b-modal id="bv-modal-update-form-leaver" hide-footer  :title="'Mark '+curr_emp_name+' as leaver'" size="lg">
            <b-form @submit.stop.prevent="popupSubmit">
            <b-overlay :show="popupoverlay" rounded="sm" class='showoverlay-trz'>

               <div class="clearfix row">

                <div class="col-md-5">
                     <b-form-group id="leave_date-group" label="Enter leave date" label-for="leave_date" class="m-2">
                        <b-form-datepicker id="leave_date" name="leave_date" v-model="leave_date" :aria-required="true" v-validate="{ required: true}" :min="last_payslip_date"></b-form-datepicker>
                        <b-form-invalid-feedback id="leave_date">{{ veeErrors.first('leave_date') }}</b-form-invalid-feedback>
                    </b-form-group>

                    <template v-if="addons.includes('Pf') && $atl_company_package_title != 'Provident Fund Only'">
                            <b-form-group id="pf-end-date-group" class='m-2'>
                            <b-form-checkbox id="checkbox-2" v-model="pf_end_date_enable"  name="pf_end" value=1 unchecked-value=0 >
                            End PF Entitlement of this employee on leave date.
                            </b-form-checkbox>
                            </b-form-group>
                    </template>
                </div>
    		  </div>

               <div class="clearfix row"> <div class="col-md-5"><b-button class = "m-2" type="submit">SAVE</b-button></div></div>

              </b-overlay>
              </b-form>
            </b-modal>

        </div>


    <b-alert
      v-model="showTop"
      class="position-fixed fixed-top m-0 rounded-0 multi-line"
      style="z-index: 20000000;"
      variant="danger"
      dismissible
    >
      <span v-html="error_messages"></span>
    </b-alert>

    </b-overlay>
</template>
<style scoped>
button.disabled{cursor: default;}
.multi-line {
  white-space: pre-line;
}
</style>

<script>
    export default{
        props: ['current_month','current_fiscal_year'],

        data(){
            let sortOrders = {};
            let columns = [
                            {label: 'Name', name: 'name' },
                            {label: 'Employee Code', name: 'employee_code' },
                            {label: 'Job Position', name: 'jobposition'},
                            {label: 'Department', name: 'department'},
                            {label: 'Leave Date', name: 'leave_date'},
                        ];
            columns.forEach((column) => {sortOrders[column.name] = -1;});
            return {
                /** Sohel Code Starts Here */
                  //this_search : '',
                  temp_length: 10,

                  /** Sohel Code Ends Here */

                company_name: '',
                emp_list_data : [],

                showoverlay : true,
                popupoverlay: false,
                pf_end_date_enable: 0,
                pf_end_date_enable_bulk:0,
                empdata: [],
                m_search_data: [],
                addons:[],
                emp_pf_title: '',
                emp_btn_title: '',

                curr_emp_name: '',
                curr_emp_id: 0,
                leave_date: '',
                atl_company_package_title: this.$atl_company_package_title,

                notice: "",
                blankmsg : 'Fetching data..',
                people:0,


                search:'',
                length_options: [{ value: 10, text: "10" },{ value: 20, text: "20" },{ value: 30, text: "30" },{ value: 40, text: "40" },{ value: 50, text: "50" }],



                columns: columns,
                sortKey: 'name',
                sortOrders: sortOrders,
                length : 10,
                pagination : {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},

                emp_leaver_file : null,
                last_payrun_date: '',
                last_payslip_date: '',
                monthNames : ["January", "February", "March", "April", "May", "June","July", "August", "September", "October", "November", "December"],
                showTop: false,
                error_messages: '',
            }
        },
        methods:{

            getAcl: function()
            {
                axios.get(this.$api_url+'/acl' , {
                    params: {
                        url: this.cu
                    }
                }).then(function(response){
                    this.ce = response.data;
                }.bind(this));
            },


            getEmployeeListData: function(){
            let currentObj = this;
            this.showoverlay = true;
              axios.get(this.$api_url+'/employee/filteredlist', {
                    params: {
                        status: 1,
                        leaver: 1,
                        per_page: this.length,
                        s_page: this.pagination.currentPage,
                        s_key: this.search,
                        fiscal_year: this.current_fiscal_year,
                        fiscal_month: this.current_month
                    }
                    })
              .then(function (response) {
                 this.showoverlay = false;
                 if(response.data.data)
                    this.emp_list_data = response.data.data.employees;

                 //this.length = response.data.data.per_page;
                 //this.pagination.currentPage = response.data.data.current_page;
                 //console.log(this.emp_list_data);

                //this.users = response.data;
                if(this.atl_company_package_title == 'Provident Fund Only')
                {
                    this.pf_end_date_enable= 1;
                    this.pf_end_date_enable_bulk= 1;
                }

                if(response.data.data == 0)
                    this.blankmsg = "No employee found with active contract";

                else
                    this.sortBy('name');

                this.people = this.emp_list_data.length;

                 //this.paginate(response.data.data.total, this.length, this.pagination.currentPage)
              }.bind(this)).catch(function (error){currentObj.showoverlay = false; currentObj.serverError(error);

              console.log(error);
              });

            },
            loadLastPayrunDate(){
               axios.get(this.$api_url+'/get_company_last_payrun_date', {
                    params: {
                    }
               }).then(function(response){
                    if(response.data){
                     this.last_payrun_date =  response.data;
                    }else{
                      this.last_payrun_date = '';
                    }
               }.bind(this));
            },


            uploadLeaverFile:function(event)
            {
                if(!this.checkNet()) return false;

                this.show_employee_list = false;
                this.errormsg = [];
                // this function upload the logo
                this.emp_leaver_file = event.target.files[0];
                if(this.emp_leaver_file){
                this.showoverlay = true;
                const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }
                const data = new FormData();
                data.append('leaver_file', this.emp_leaver_file);
                data.append('pf_end_date_enable_bulk', this.pf_end_date_enable_bulk);

                /*this.$bvToast.toast('Processing leaver data file.', {
                                            title: 'Job in progress',
                                            variant: 'info',
                                            solid: true
                                        });  */

                /*Payroll Levaer update: 1 Start*/
                 let confirm_message = 'Please confirm that all leave dates are correct. Any contracts that began before leave date will be terminated, and the process cannot be reversed.';
                 this.$bvModal.msgBoxConfirm(confirm_message, {title: 'Confirm leavers bulk update!', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'YES', cancelTitle: 'NO', footerClass: 'p-2', hideHeaderClose: false,centered: true})
.then(value => {
           if(value)
                  {
                    //alert('here');
                    //return;
           /*Payroll Levaer update: 1 End*/
                axios.post(this.$api_url+'/leaver/processdata', data , config).
                    then(function (response){
                      if(response.data.status){
                        if(response.data.msg)
                        this.$bvToast.toast(response.data.msg, {title: 'Success',variant: 'success',solid: true});
                      }else{
                        if(response.data.msg){
                        //this.$bvToast.toast(response.data.msg, {title: 'Error!',variant: 'danger',solid: true});
                         this.error_messages = response.data.msg;
                         this.showTop = true;

                        }
                        else
                        this.$bvToast.toast("Unable to process. Server error!!!", {title: 'Error!',variant: 'danger',solid: true});
                      }

                      this.getEmployeeListData();
                      this.showoverlay = false;
                    }.bind(this)).
                    catch(function (error)
                            {
                                //alert(error.response.data.errors);
                                this.showoverlay = false;
                            });
                 /*Payroll Levaer update: 1 Start*/
                     }else{
                        this.showoverlay = false;
                     }

                    })
                .catch(err => {
                    // An error occurred
                    });
                    /*Payroll Levaer update: 1 End*/
                }else{
                    this.showoverlay = false;
                }
            },


            updateLeaver: function(emp_id,emp_name)
            {
            //this.popupoverlay = true;
            this.curr_emp_name = emp_name;
            this.curr_emp_id = emp_id;
            this.pf_end_date_enable = 0;
            this.leave_date = '';
            this.loadLastPayslipDate();
            this.$bvModal.show('bv-modal-update-form-leaver');
           },

           loadLastPayslipDate(){
              this.popupoverlay = true;
              axios.get(this.$api_url+'/get_employee_last_payslip_date', {
                                params: {
                                    employee_id: this.curr_emp_id
                                }
                        }).then(function(response){
                        if(response.data){
                         this.last_payslip_date =  response.data;
                        }else{
                          this.last_payslip_date = '';
                        }

                this.popupoverlay = false;
               }.bind(this));
            },

           popupSubmit(e)
            {
                e.preventDefault();
                let currentObj = this;
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }

                let date_payrun = '';
                let date_leave = '';
                let date_leave_day = '';
                let pay_run_last_day = '';
                let formData = new FormData();
                formData.append('employee_id', this.curr_emp_id);
                formData.append('leave_date', this.leave_date);
                formData.append('pf_end_date_enable', this.pf_end_date_enable);

                let user_dis_name = 'this user';
                if(this.curr_emp_name && this.curr_emp_name.length>0)
                user_dis_name = this.curr_emp_name;

                //if(this.leave_date && (new Date(this.leave_date) - new Date() >= 0 )){
                if(this.leave_date){

                let last_pay_date_error = false;



                if(this.last_payslip_date.length>0){
                  date_payrun = new Date(Date.parse(this.last_payslip_date));
                  date_leave = new Date(this.leave_date);
                  //let test_before = date_payrun.getDate() - 1;
                  date_payrun.setDate(date_payrun.getDate() - 1);
                  //alert(date_payrun);
                  //return 1;


                  if(date_leave.getFullYear() < date_payrun.getFullYear())
                  last_pay_date_error = true;
                  else if(date_leave.getFullYear() == date_payrun.getFullYear()){
                    if(date_leave <= date_payrun)
                    last_pay_date_error = true;
                  }

                }


                 if(!last_pay_date_error){
                 /*Payroll Levaer update: 1 Start*/
                 let confirm_message = 'Please confirm that the leave date is correct. All contracts that began before this date will be terminated, and the process cannot be reversed.';
                 this.$bvModal.msgBoxConfirm(confirm_message, {title: 'Confirm mark as leaver!', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'YES', cancelTitle: 'NO', footerClass: 'p-2', hideHeaderClose: false,centered: true})
.then(value => {
           if(value)
                  {
                 /*Payroll Levaer update: 1 End*/
                 axios.post(this.$api_url+'/saveleaverdata', formData, config)
                            .then(function (response)
                            {
                                if(response.data.success){
                                 this.$bvToast.toast("Successfully marked as leaver", {title: 'Success',variant: 'success',solid: true});
                                 this.$bvModal.hide('bv-modal-update-form-leaver');
                                 this.getEmployeeListData();
                                }
                            }.bind(this))
                            .catch(function (error)
                            {
                                //currentObj.errormsg = error.response.data.errors;
                            });
                   /*Payroll Levaer update: 1 Start*/
                     }
                    })
                .catch(err => {
                    // An error occurred
                    });
                    /*Payroll Levaer update: 1 End*/
                  }else{



                    //this.$bvToast.toast('Leaver date can not be prior to '+this.monthNames[date_payrun.getMonth()]+' '+pay_run_last_day+' - '+date_payrun.getFullYear()+' since this company has an Draft / Approved Payrun created until  '+this.monthNames[date_payrun.getMonth()]+' '+pay_run_last_day+' - '+date_payrun.getFullYear(), {title: 'Error!',variant: 'danger',solid: true});
                    this.$bvToast.toast('Leaver date can not be prior to '+this.monthNames[date_payrun.getMonth()]+' - '+date_payrun.getFullYear()+' since '+user_dis_name+' has an Draft / Approved Payslip created under  '+this.monthNames[date_payrun.getMonth()]+' - '+date_payrun.getFullYear()+' Payrun.', {title: 'Error!',variant: 'danger',solid: true});

                 }
                }else{
                    this.$bvToast.toast("Please enter valid date", {title: 'Error!',variant: 'danger',solid: true});
                }
            },

            getCompanyData:function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/company/details?f=1' , {
                    params: {
                        //id: x
                    }
                }).then(function(response){

                    if(response.data.length != 0)
                    {
                        this.addons =  response.data.module_disabled;
                    }
                    else
                    {

                    }

                }.bind(this));


            }
        },
        created: function(){
            this.getCompanyData();
            this.getAcl();
            this.loadLastPayrunDate();
            this.getEmployeeListData();


            Fire.$on('reloadUsers', () => {this.getEmployeeListData()});
        },
        computed:
        {
            filteredData()
            {
                let filtered_list = this.emp_list_data ? this.emp_list_data: [];
                if (this.search)
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});

                    if(filtered_list.length == 0)
                        this.blankmsg = "Nothing found.";
                }

                let sortKey = this.sortKey;
                let order = this.sortOrders[sortKey] || 1;
                if (sortKey)
                {
                    filtered_list = filtered_list.slice().sort((a, b) => {let index = this.getIndex(this.columns, 'name', sortKey);
                            a = String(a[sortKey]).toLowerCase();
                            b = String(b[sortKey]).toLowerCase();
                            if (this.columns[index].type && this.columns[index].type === 'date')
                            {
                                return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                            }
                            else if (this.columns[index].type && this.columns[index].type === 'number')
                            {
                                return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
                            }
                            else
                            {
                                return (a === b ? 0 : a > b ? 1 : -1) * order;
                            }
                        }
                    );
                }

                return filtered_list;
            },
            paginatedData()
            {
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            }
        }
    }
</script>

<style>
.showoverlay-trz .b-overlay {
	height: 100%;
}
</style>
